import { EPlayerEvent } from './enums';

class Player {

	protected audio: HTMLAudioElement;
	protected eventHandlers: { [key in EPlayerEvent]: Function[] } = {
		[EPlayerEvent.PLAY]: [],
		[EPlayerEvent.PAUSE]: [],
	};

	constructor() {
		if (!IS_SSR) {
			this.audio = new Audio();
			this.audio.addEventListener('play', this.onPlay);
			this.audio.addEventListener('pause', this.onPause);
		}
	}

	setUrl(url: string) {
		this.audio.src = url;
	}

	play() {
		void this.audio.play();
	}

	pause() {
		void this.audio.pause();
	}

	toggle() {
		if (this.audio.paused) {
			this.play();
		} else {
			this.pause();
		}
	}

	on(eventName: EPlayerEvent, handler: Function) {
		this.eventHandlers[eventName].push(handler);
	}

	off(eventName: EPlayerEvent, handler: Function) {
		this.eventHandlers[eventName] = this.eventHandlers[eventName].filter((item) => item !== handler);
	}

	protected trigger(eventName: EPlayerEvent) {
		this.eventHandlers[eventName].forEach((item) => item());
	}

	protected onPlay = () => {
		this.trigger(EPlayerEvent.PLAY);
	};

	protected onPause = () => {
		this.trigger(EPlayerEvent.PAUSE);
	};

}

export const player = new Player();
